import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { contextConnect } from '@wp-g2/context';
import React from 'react';
import { BaseChoice, useBaseChoice } from '../BaseChoice';
import CheckboxElement from './CheckboxElement';

function Checkbox(props, forwardedRef) {
  var _useBaseChoice = useBaseChoice(props, 'Checkbox'),
      baseChoice = _useBaseChoice.baseChoice,
      otherProps = _objectWithoutProperties(_useBaseChoice, ["baseChoice"]);

  return /*#__PURE__*/React.createElement(BaseChoice, baseChoice, /*#__PURE__*/React.createElement(CheckboxElement, Object.assign({}, otherProps, {
    ref: forwardedRef
  })));
}

export default contextConnect(Checkbox, 'Checkbox');